import { publicProjects } from "@/mocks/publico";
import { PublicProjectStatusBadge } from "./PublicBadges";

export default function PublicProjectsSection() {
  const tipos = ["Todos", ...Array.from(new Set(publicProjects.map((p) => p.tipo)))];

  return (
    <section id="projetos" className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">Projetos Ambientais Públicos</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Acompanhe os projetos de inventário arbóreo, recuperação ambiental, compensação e carbono urbano em andamento.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {publicProjects.map((project) => (
            <div
              key={project.id}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-background-300/60 transition-colors"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                  <i className="ri-folder-chart-line text-primary-600 text-lg w-5 h-5 flex items-center justify-center" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 leading-snug">{project.nome}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{project.municipio} · {project.bairro}</p>
                </div>
              </div>

              <div className="flex flex-wrap gap-2 mb-3">
                <PublicProjectStatusBadge status={project.status} />
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-background-100 text-foreground-600 whitespace-nowrap">
                  {project.tipo}
                </span>
              </div>

              {/* Progress */}
              <div className="mb-3">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-foreground-500">Progresso</span>
                  <span className="text-xs font-semibold text-foreground-900">{project.progresso}%</span>
                </div>
                <div className="w-full bg-background-200 rounded-full h-1.5">
                  <div
                    className="h-1.5 rounded-full bg-primary-500 transition-all duration-500"
                    style={{ width: `${project.progresso}%` }}
                  />
                </div>
              </div>

              <div className="flex flex-wrap gap-4 text-xs text-foreground-500 mb-4">
                <span>
                  <i className="ri-plant-line w-3 h-3 inline-flex items-center justify-center mr-1" />
                  {project.arvores} árvores
                </span>
                <span>
                  <i className="ri-ruler-line w-3 h-3 inline-flex items-center justify-center mr-1" />
                  {project.area}
                </span>
              </div>

              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">Atualizado: {project.ultimaAtualizacao}</span>
                <button className="text-xs font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer">
                  Ver detalhes <i className="ri-arrow-right-line w-3 h-3 inline-flex items-center justify-center ml-0.5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}